/* eslint react/prop-types:0 */
import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { ForgeGlobalPageExtensionPoint } from '@confluence/forge-ui/entry-points/GlobalPage';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';

export const GlobalPageForgeAppsRoute = ({ params: { appId, envId, forgeManifestRoute } }) => {
	return (
		<Screen
			screenEvent={{
				name: 'globalPageScreen',
				id: appId,
				attributes: { appId, envId, forgeManifestRoute },
			}}
		>
			<MainLayout navView={PRODUCT_HOME_ID}>
				<ForgeGlobalPageExtensionPoint
					key={`${appId}-${envId}-${forgeManifestRoute}`}
					appId={appId}
					envId={envId}
					forgeManifestRoute={forgeManifestRoute}
				/>
			</MainLayout>
		</Screen>
	);
};
